<fieldset class="plain flex-grow-1" [disabled]="readonly()">
<form [formGroup]="supplierCreditNoteForm">
  <kendo-panelbar rcPanelBarNoCollapse [animate]="false" [expandMode]="expandMode">
    <kendo-panelbar-item
      iconClass="rc-icon-file-invoice"
      [title]="'DOCUMENT' | translate | capitalize"
      [expanded]="true">
      <ng-template kendoPanelBarContent>
        <div class="grid template-cols-4">
          <div class="d-flex flex-column g-col-4">
            <kendo-formfield showHints="initial" showErrors="initial">
              <kendo-label
                labelCssClass="k-form-label"
                [for]="creditNoteDate"
                [text]="'CREDIT_NOTE_DATE' | translate | capitalize"></kendo-label>
              <div><span #creditNoteDate>
                {{ supplierCreditNote()?.creditNoteDate | kendoDate: "dd/MM/yyyy" }}
              </span></div>
            </kendo-formfield>
          </div>

          <div class="d-flex flex-column g-col-4">
            <kendo-formfield showHints="initial" showErrors="initial">
              <kendo-label
                labelCssClass="k-form-label"
                [for]="creditNoteWeek"
                [text]="'CREDIT_NOTE_WEEK' | translate | capitalize"></kendo-label>
              <div><span #creditNoteWeek>
                {{ supplierCreditNote()?.creditNoteDateAsWeekFormat ?? '-' }}
              </span></div>
            </kendo-formfield>
          </div>

          <div class="d-flex flex-column g-col-4">
            <kendo-formfield showHints="initial" showErrors="initial">
              <kendo-label
                labelCssClass="k-form-label"
                [for]="reference"
                [text]="'REFERENCE' | translate | capitalize"></kendo-label>
              <div><span #reference>
                {{ supplierCreditNote()?.reference ?? '-' }}
              </span></div>
            </kendo-formfield>
          </div>
        </div>
      </ng-template>
    </kendo-panelbar-item>
    <kendo-panelbar-item
      iconClass="rc-icon-skyscraper"
      [title]="'SUPPLIER' | translate | capitalize">
      <ng-template kendoPanelBarContent>
        <div class="grid template-cols-4">
          <div class="d-flex flex-column g-col-4">
            <kendo-formfield showHints="initial" showErrors="initial">
              <kendo-label
                labelCssClass="k-form-label"
                [for]="rcSupplier"
                [text]="('SUPPLIER' | translate | capitalize) + ' ROYAL CROWN'"></kendo-label>
              <a #rcSupplier class="rc-string-button !k-text-no-underline p-0 h-unset"
                 [href]="supplierCreditNote()!.supplier"
                 target="_blank" [rel]="'noopener noreferrer'"><span
                class="!k-text-underline underline-offset-2">{{ supplierCreditNote()?.supplierName }}</span> <i
                class="rc-icon-external-link !k-text-no-underline fs-16 ps-8 fc-neutral-800"></i></a>
            </kendo-formfield>
          </div>

          <div class="d-flex flex-column g-col-4">
            <kendo-formfield showHints="initial" showErrors="initial">
              <kendo-label
                labelCssClass="k-form-label"
                [for]="address"
                [text]="('ADDRESS' | translate | capitalize)"></kendo-label>
              <div #address class="d-flex flex-column">
                <span>{{ supplierCreditNote()?.supplierAddressStreet }}</span>
                <span>{{ supplierCreditNote()?.supplierAddressCity }}</span>
              </div>
            </kendo-formfield>
          </div>

          <div class="d-flex flex-column g-col-4">
            <kendo-formfield showHints="initial" showErrors="initial">
              <kendo-label
                labelCssClass="k-form-label"
                [for]="vat"
                [text]="('VAT_NUMBER' | translate | capitalize)"></kendo-label>
              <div #vat class="d-flex flex-column">
                <span>{{ supplierCreditNote()?.supplierVatNumber }}</span>
              </div>
            </kendo-formfield>
          </div>
        </div>
      </ng-template>
    </kendo-panelbar-item>
    <kendo-panelbar-item
      iconClass="rc-icon-truck-delivery"
      [title]="'DELIVERY' | translate | capitalize">
      <ng-template kendoPanelBarContent>
        <div class="grid template-cols-4">
          <div class="d-flex flex-column g-col-4">
            <kendo-formfield showHints="initial" showErrors="initial">
              <kendo-label
                labelCssClass="k-form-label"
                [for]="address"
                [text]="('DELIVERY_ADDRESS' | translate | capitalize)"></kendo-label>
              <div #address class="d-flex flex-column">
                <span>{{ supplierCreditNote()?.deliveryAddressName }}</span>
                <span>{{ supplierCreditNote()?.deliveryAddressStreet }}</span>
                <span>
                  {{ supplierCreditNote()?.deliveryAddressPostalCode }}
                  {{ supplierCreditNote()?.deliveryAddressCity }}
                  {{ supplierCreditNote()?.deliveryAddressUnit }}
                </span>
                <span>{{ supplierCreditNote()?.deliveryAddressCountry }}</span>
              </div>
            </kendo-formfield>
          </div>

          <div class="d-flex flex-column g-col-4">
            <kendo-formfield showHints="initial" showErrors="initial">
              <kendo-label
                labelCssClass="k-form-label"
                [for]="vat"
                [text]="('DELIVERY_RECEIPT_NUMBER' | translate | capitalize)"></kendo-label>
              <div #vat class="d-flex flex-column">
                <span>{{ supplierCreditNote()?.deliveryDocumentNumber ?? '-' }}</span>
              </div>
            </kendo-formfield>
          </div>
          <div class="d-flex flex-column g-col-4">
            <kendo-formfield showHints="initial" showErrors="initial">
              <kendo-label
                labelCssClass="k-form-label"
                [for]="vat"
                [text]="('DELIVERY_DATE' | translate | capitalize)"></kendo-label>
              <div #vat class="d-flex flex-column">
                <span>{{ supplierCreditNote()?.deliveryDate  | kendoDate : 'dd/MM/yyyy' }}</span>
              </div>
            </kendo-formfield>
          </div>
        </div>
      </ng-template>
    </kendo-panelbar-item>
    <kendo-panelbar-item
      iconClass="rc-icon-adjustments-horizontal"
      [title]="'CHARACTERISTICS' | translate | capitalize">
      <ng-template kendoPanelBarContent>
        <div class="grid template-cols-4">
          <div class="d-flex flex-column g-col-4">
            <kendo-formfield showHints="initial" showErrors="initial">
              <kendo-label
                labelCssClass="k-form-label"
                [for]="uploadedBy"
                [text]="('UPLOADED_BY' | translate | capitalize)"></kendo-label>
              <div #uploadedBy class="d-flex flex-column">
                <span>{{ supplierCreditNote()?.uploadedBy }}</span>
                <span>{{ supplierCreditNote()?.createdOn | kendoDate : 'dd/MM/yyy HH:mm' }}</span>
              </div>
            </kendo-formfield>
          </div>

          <div class="d-flex flex-column g-col-4">
            <kendo-formfield showHints="initial" showErrors="initial">
              <kendo-label
                labelCssClass="k-form-label"
                [text]="('COMPLAINT' | translate | capitalize)"></kendo-label>
              @if (supplierCreditNote()?.complaint) {
                <a #complaint class="rc-string-button !k-text-no-underline p-0 h-unset"
                   [href]="supplierCreditNote()!.complaint"
                   target="_blank" [rel]="'noopener noreferrer'">
                  <span class="!k-text-underline underline-offset-2">
                    {{ "MANAGE_COMPLAINT" | translate | capitalize }}
                  </span>
                  <i class="rc-icon-external-link !k-text-no-underline fs-16 ps-8 fc-neutral-800"></i>
                </a>
              } @else {
                -
              }
            </kendo-formfield>
          </div>

          <div class="d-flex flex-column g-col-4">
            <kendo-formfield showHints="initial" showErrors="initial">
              <kendo-label
                labelCssClass="k-form-label"
                [for]="doNotInvoice"
                [text]="('DO_NOT_CREDIT' | translate | capitalize)"></kendo-label>
              <kendo-switch
                #doNotInvoice
                rcValidation
                [checked]="!!supplierCreditNote()?.doNotCredit"
                [offLabel]="''"
                [onLabel]="''"
                (valueChange)="updateForm()"
                [readonly]="readonly()"
                [rcDisabled]="isDoNotCreditSwitchLocked()"
                formControlName="doNotCredit"
              />
            </kendo-formfield>
          </div>

          <div class="g-col-4 d-flex flex-column">
            <kendo-formfield showHints="initial" showErrors="initial">
              <kendo-label
                labelCssClass="k-form-label"
                [for]="tagsview"
                [text]="'TAGS' | translate | capitalize"></kendo-label>
              <kendo-multiselect
                rcMultiSelectWrapPadding
                [data]="(tags$ | async) ?? []"
                [valueField]="'@id'"
                [textField]="'name'"
                [filterable]="true"
                (filterChange)="filterTags($event)"
                (valueChange)="updateTags($event)"
                [valuePrimitive]="true"
                rcValidation
                formControlName="tags"
                #tagsview></kendo-multiselect>
            </kendo-formfield>
          </div>
        </div>
      </ng-template>
    </kendo-panelbar-item>
    <kendo-panelbar-item iconClass="rc-icon-coin-euro" [title]="'EXTRA_COSTS' | translate | capitalize">
      <ng-template kendoPanelBarContent>
        @let extraCosts = extraCosts$ | async;
        @if (extraCosts) {
          <div class="grid template-cols-4">
            <div class="g-col-4 d-flex flex-column">
              <div class="grid template-cols-4 gap-8">
                @for (cost of extraCosts; track cost['@id']) {
                  <rc-document-fee-card
                    [fee]="cost"
                    [vatCodeEditable]="!isSupplierCreditNoteLocked() && !readonly()"
                    (vatCodeChange)="updateTotals.emit(true)" />
                }
              </div>
<!--              <button-->
<!--                type="button"-->
<!--                class="me-2 ms-auto link-button"-->
<!--                kendoButton-->
<!--                fillMode="link"-->
<!--                [disabled]="isSupplierCreditNoteLocked() || readonly()"-->
<!--                (click)="openCreateExtraCostDialog()">-->
<!--                + {{ "ADD_ENTITY" | translate: { entity: ("EXTRA_COST" | translate) } | capitalize }}-->
<!--              </button>-->
            </div>
          </div>
        } @else {
          <kendo-loader [type]="'converging-spinner'"></kendo-loader>
        }
      </ng-template>
    </kendo-panelbar-item>
    <kendo-panelbar-item
      iconClass="rc-icon-paperclip"
      [title]="'ATTACHMENTS' | translate | capitalize">
      <ng-template kendoPanelBarContent>
        <div class="grid template-cols-4">
          <div class="d-flex flex-column g-col-4">
            <rc-file-upload
              [wrapperClasses]="'flex-column'"
              [uploadUrl]="uploadUrl"
              [isLoading]="loading()"
              (updated)="markAsDirty($event)"
              [attachments]="supplierCreditNoteAttachmentsForm.controls.media.value"
              [warningAlert]="{show: true, message: 'COMBINED_FILESIZE_WARNING' | translate:{size: 30} | capitalize}"
              [disabled]="isSupplierCreditNoteLocked() || readonly()"
            >
            </rc-file-upload>
          </div>
        </div>
      </ng-template>
    </kendo-panelbar-item>
    <kendo-panelbar-item
      iconClass="rc-icon-linked-files"
      [title]="'ASSOCIATIONS' | translate | capitalize">
      <ng-template kendoPanelBarContent>
        <rc-document-links [documentIri]="supplierCreditNote()?.['@id']!"></rc-document-links>
      </ng-template>
    </kendo-panelbar-item>
  </kendo-panelbar>
</form>
</fieldset>
